export default __webpack_public_path__ + "static/media/MINUSMA_justice_and_reconciliation.a90808d4.jpg";